<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-if="mode === 'new' || mode === 'edit'">
            <validationObserver ref="addDataForm" tag="form">
              <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ชื่อ</label>
                  <div class="col-lg-6">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Catalog Type Name"
                      :rules="{
                        dynamicRequired: [
                          'กรุณาระบุชื่อประเภท Catalog เป็นภาษาอังกฤษ',
                        ],
                        duplicateName: [
                          isValidate.display_name,
                          'ชื่อประเภท Catalog ซ้ำกับข้อมูลที่อยู่ในระบบ',
                        ],
                        validateEng: true,
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="input_displayname"
                          name="input_displayname"
                          type="text"
                          class="form-control"
                          placeholder="ชื่อประเภท Catalog"
                          maxlength="30"
                          v-model="model.display_name.en"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) &&
                              model.display_name.en,
                          }"
                          v-on:keyup="onValidateDisplayname($event)"
                        />
                        <span class="input-group-append">
                          <span class="input-group-text"
                            >{{ model.display_name.en.length }}/30
                          </span>
                        </span>
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <div class="col-lg-2">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Catalog Type Status"
                      :rules="{
                        dynamicRequired: ['กรุณาเลือกสถานะ'],
                      }"
                    >
                      <multiselect
                        name="Catalog Type Status"
                        v-model="model.status"
                        :options="
                          mode === 'new'
                            ? optionsStatus.filter(f => f !== 'Delete')
                            : optionsStatus
                        "
                        :show-labels="false"
                        :allowEmpty="false"
                        placeholder="เลือกสถานะ"
                        :class="{
                          'is-invalid': errors && errors.length,
                        }"
                      >
                        <template slot="placeholder">
                          <span>เลือกสถานะ</span>
                        </template>
                      </multiselect>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4" v-if="mode === 'edit'">
                  <label class="col-form-label col-lg-2">Catalogs</label>
                  <div class="col-lg-10">
                    <b-table
                      class="table table-centered table-nowrap"
                      ref="catalogtable"
                      :empty-text="'ไม่พบข้อมูล'"
                      :show-empty="
                        model.catalogs === null ||
                          model.catalogs === undefined ||
                          (model.catalogs && model.catalogs.length === 0)
                      "
                      :bordered="true"
                      :items="model.catalogs"
                      align="center"
                      v-bind:fields="fields"
                    >
                      <template v-slot:cell(index)="data">
                        <div class="text-right">
                          {{ (data.index + 1) | number }}
                        </div>
                      </template>
                      <template v-slot:cell(status)="data">
                        <span
                          class="label"
                          :class="'label-' + data.value.toLowerCase()"
                          v-html="data.value"
                        ></span>
                      </template>
                      <template v-slot:cell(action)="data">
                        <div class="text-center">
                          <a
                            @click="
                              $router.push({
                                name: 'catalog_detail',
                                params: { id: data.item.id },
                              })
                            "
                            class="btn btn-ico text-info"
                            title="View"
                            ><i class="bx bx-show"></i
                          ></a>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="text-left">
                      <div class="button-items">
                        <button
                          @click="onBack()"
                          type="button"
                          class="btn btn-light"
                        >
                          <i class="bx bx-arrow-back" />Back
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <div class="button-items">
                        <button type="submit" class="btn btn-primary">
                          <i class="bx bx-save" />Save
                        </button>
                        <button type="reset" class="btn btn-light">
                          <i class="bx bx-reset" />Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
          <div class="card-body" v-if="mode === 'view'">
            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="text-sm-right">
                  <button
                    v-if="model.status !== 'Delete'"
                    @click="changeMode('edit')"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ชื่อ</label>
              <label class="col-form-label col-lg-8">{{
                model.display_name.en
              }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <span
                class="ml-2 label"
                :class="'label-' + model.status.toLowerCase()"
                v-html="model.status"
              ></span>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Catalogs</label>
              <div class="col-lg-10">
                <b-table
                  class="table table-centered table-nowrap"
                  ref="catalogtable"
                  :empty-text="'ไม่พบข้อมูล'"
                  :show-empty="
                    model.catalogs === null ||
                      model.catalogs === undefined ||
                      (model.catalogs && model.catalogs.length === 0)
                  "
                  :bordered="true"
                  :items="model.catalogs"
                  align="center"
                  v-bind:fields="fields"
                >
                  <template v-slot:cell(index)="data">
                    <div class="text-right">
                      {{ (data.index + 1) | number }}
                    </div>
                  </template>
                  <template v-slot:cell(status)="data">
                    <span
                      class="label"
                      :class="'label-' + data.value.toLowerCase()"
                      v-html="data.value"
                    ></span>
                  </template>
                  <template v-slot:cell(action)="data">
                    <div class="text-center">
                      <a
                        @click="
                          $router.push({
                            name: 'catalog_detail',
                            params: { id: data.item.id },
                          })
                        "
                        class="btn btn-ico text-info"
                        title="View"
                        ><i class="bx bx-show"></i
                      ></a>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="form-group mb-4 text-left">
              <div class="button-items">
                <button @click="onBack()" type="button" class="btn btn-light">
                  <i class="bx bx-arrow-back" />Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import { FormatDate } from '@/helpers/utils/format-date.js'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import catalogtypeService from '@/helpers/service/catalogtype-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import { OptionStatus } from '@/helpers/utils/status.js'
import Multiselect from 'vue-multiselect'

export default {
  page: {
    title: 'Catalog Type',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader, Multiselect },
  data() {
    return {
      id: '',
      title: 'View',
      mode: 'view',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Catalog Type',
          href: '/catalog-types',
        },
        {
          text: 'View',
          active: true,
        },
      ],
      model: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        catalogs: [],
        status: StatusEnum.ACTIVE,
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'display_name.th',
          label: 'ชื่อ (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name.en',
          label: 'ชื่อ (อังกฤษ)',
          sortable: true,
        },
        // {
        //   key: 'type.display_name.en',
        //   label: 'ประเภท',
        //   sortable: true,
        // },
        {
          key: 'catalog_start_date',
          label: 'วันที่เริ่มต้น',
          formatter: (value, key, item) => {
            return FormatDate(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'catalog_end_date',
          label: 'วันที่สิ้นสุด',
          formatter: (value, key, item) => {
            return FormatDate(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'status',
          label: 'สถานะ',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      isValidate: {
        display_name: false,
        status: false,
      },
      reloadStatusSelector: false,
      optionsStatus: [],
    }
  },
  created: function() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
      this.title = 'New Catalog Type'
      this.items[2].text = 'New'
    } else {
      this.title = 'Detail'
      this.items[2].text = 'Detail'
      this.id = this.$route.params.id
    }
    if (this.$route.query.mode) {
      this.title = 'Edit Catalog Type'
      this.items[2].text = 'Edit'
      this.mode = this.$route.query.mode
    }
  },
  mounted: function() {
    this.optionsStatus = OptionStatus
    if (this.mode !== 'new') {
      this.getDetail()
    }
  },
  methods: {
    async getDetail() {
      let result = await catalogtypeService.getCatalogTypeMasterDetailAsync(
        this.id
      )
      if (result.status === 200) {
        this.model = result.data
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            if (this.mode === 'new') {
              this.model.display_name.en = ''
              this.model.status = StatusEnum.ACTIVE
              this.defaultDate = []
            } else {
              this.getDetail()
            }
          }
        })
    },
    onBack() {
      this.$router.push({
        path: '/catalog-types',
      })
    },
    changeMode(_mode) {
      if (_mode == 'edit') {
        this.mode = 'edit'
        this.title = 'Edit Catalog Type'
        this.items[2].text = 'Edit'
        this.getDetail()
      } else if (_mode == 'new') {
        this.mode = 'new'
        this.title = 'New Catalog Type'
        this.items[2].text = 'New'
      }
    },
    async onSubmit() {
      this.$refs.addDataForm.validate().then(async response => {
        if (response) {
          if (this.mode === 'new') {
            await this.onSaveCreate()
          } else {
            if ((await this.validateBeforeSave()) === true) {
              await this.onSave()
            }
          }
        }
      })
    },
    async onSave() {
      this.removeLastAndFirstSpacesFromString()
      this.model.display_name.th = this.model.display_name.en
      let result = await catalogtypeService.updateCatalogTypeMasterAsync(
        this.id,
        this.model
      )
      if (result.status && result.status === 204) {
        this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
        this.$router.push({
          path: '/catalog-types',
        })
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onSaveCreate() {
      this.removeLastAndFirstSpacesFromString()
      this.model.display_name.th = this.model.display_name.en
      let result = await catalogtypeService.createCatalogTypeMasterAsync(
        this.model
      )
      if (result.status === 201) {
        this.$utils.notification('success', 'เพิ่มข้อมูลสำเร็จ', 1500)
        this.$router.push({
          path: '/catalog-types',
        })
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onValidateDisplayname() {
      if (
        !(
          this.model.display_name.en.trim() === '' ||
          this.model.display_name.en.trim() === null ||
          this.model.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('name', this.model.display_name.en.trim())
        if (this.mode === 'edit') {
          params.append('id', this.id)
        }
        let result = await catalogtypeService.headCatalogTypeMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name = false
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    removeLastAndFirstSpacesFromString() {
      this.model.display_name = {
        en: this.model.display_name.en.trim(),
        th: this.model.display_name.th.trim(),
      }
    },
    async validateBeforeSave() {
      let isContinue
      let date = new Date()
      if (
        this.model.catalogs.some(
          s =>
            new Date(s.catalog_start_date) <= date &&
            new Date(s.catalog_end_date) >= date
        )
      ) {
        if (this.model.status !== 'Delete') {
          await this.$utils
            .confirmAlertDisplay(
              `มี Catalog ที่ยังไม่หมดช่วงเวลาที่กำหนด ต้องการแก้ไขข้อมูลใช่หรือไม่`,
              ''
            )
            .then(async resultConfirm => {
              if (resultConfirm) {
                isContinue = true
              } else {
                isContinue = false
              }
            })
        } else {
          this.$utils.notificationAck(
            'warning',
            'ไม่สามารถปรับสถานะเป็น Delete ได้',
            `มี Catalog ที่ยังไม่หมดช่วงเวลาที่กำหนด`
          )
          isContinue = false
        }
      } else if (
        this.model.catalogs === null ||
        this.model.catalogs === undefined ||
        (this.model.catalogs && this.model.catalogs.length === 0) ||
        (this.model.catalogs &&
          this.model.catalogs.some(
            s =>
              new Date(s.catalog_start_date) >= date ||
              new Date(s.catalog_end_date) <= date
          ))
      ) {
        await this.$utils
          .confirmAlertDisplay(
            this.model.status !== 'Delete'
              ? 'ต้องการแก้ไขข้อมูลใช่หรือไม่?'
              : `ข้อมูลที่ถูก Delete จะไม่สามารถนำกลับมาใช้งานใหม่ได้ ต้องการ Delete ข้อมูลนี้ใช่หรือไม่?`,
            ''
          )
          .then(async resultConfirm => {
            if (resultConfirm) {
              isContinue = true
            } else {
              isContinue = false
            }
          })
      } else {
        isContinue = true
      }

      return isContinue
    },
  },
}
</script>
